import { createSelector } from 'reselect';
import { CONNECT_DEVICE_DIALOG } from './constants';
import { initialState } from './reducer';

export const selectState = state => state[CONNECT_DEVICE_DIALOG] || initialState;

export const selectDeviceToConnect = () => createSelector(selectState, state => state.get('deviceToConnect'));
export const selectIsSaving = () => createSelector(selectState, state => state.get('isSaving'));

